/** CollisionShape2D parser: the Node2D transform plus the shape, disabled and debug colour. */
import { parseNode2D } from '../../../base/node2d/parser';
import { parseDebugColor } from '../../shared/debugColor';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
export function parseCollisionShape2D(heading, properties) {
    const node2d = parseNode2D(heading, properties);
    const result = {
        ...node2d,
        debugColor: parseDebugColor(properties.debug_color),
    };
    if (properties.shape) {
        result.shape = properties.shape;
    }
    if (properties.disabled !== undefined) {
        result.disabled = boolSlotValue(properties.disabled) === true;
    }
    return result;
}
//# sourceMappingURL=parser.js.map